// @flow

/**
 * Module dependencies.
 */

import { isFunction } from 'lodash';

/**
 * Get branch.
 */

function getEvaluatedBranch(branch: any): any {
  return isFunction(branch) ? branch() : branch;
}

/**
 * Export `branch`.
 */

export function branch(condition: any, onTrue: any, onFalse: any = null): any {
  return condition ? getEvaluatedBranch(onTrue) : getEvaluatedBranch(onFalse);
}



// WEBPACK FOOTER //
// ../src/core/utils/branch.js